<template>
  <div class="btnDashboard"  :style="{'margin-top': marginTop,'margin-right': marginRight,'margin-left': marginLeft}">
      <el-popover
        placement="bottom"
        width="150"
        trigger="hover"
        popper-class="popperClass5"
      >
        <el-dropdown-item :disabled="language==='en'" >
          <div style="text-align: center" @click="handleSetLanguage('en')">
            English
          </div>
        </el-dropdown-item>
        <el-dropdown-item :disabled="language==='zh'">
          <div style="text-align: center"  @click="handleSetLanguage('zh')">
            <!--Chinese-->
            中文(简体)
          </div>
        </el-dropdown-item>
        <el-dropdown-item :disabled="language==='zh_ft'">
          <div style="text-align: center"  @click="handleSetLanguage('zh_ft')">
            <!--Chinese-->
            中文(繁體)
          </div>
        </el-dropdown-item>
        <el-dropdown-item :disabled="language==='fr'">
          <div style="text-align: center;width: 100%;height: 100%"  @click="handleSetLanguage('fr')">
            Français
          </div>
        </el-dropdown-item>
        <el-dropdown-item :disabled="language==='es'">
          <div style="text-align: center;width: 100%;height: 100%"  @click="handleSetLanguage('es')">
            Español
          </div>
        </el-dropdown-item>
        <el-dropdown-item :disabled="language==='pt'">
          <div style="text-align: center;width: 100%;height: 100%"  @click="handleSetLanguage('pt')">
            Português
          </div>
        </el-dropdown-item>
        <el-dropdown-item :disabled="language==='de'">
          <div style="text-align: center;width: 100%;height: 100%"  @click="handleSetLanguage('de')">
            Deutsch
          </div>
        </el-dropdown-item>
        <el-dropdown-item :disabled="language==='it'">
          <div style="text-align: center;width: 100%;height: 100%"  @click="handleSetLanguage('it')">
            Italiano
          </div>
        </el-dropdown-item>
        <el-dropdown-item :disabled="language==='ru'">
          <div style="text-align: center;width: 100%;height: 100%"  @click="handleSetLanguage('ru')">
            Русский
          </div>
        </el-dropdown-item>
        <el-dropdown-item :disabled="language==='mn'">
          <div style="text-align: center;width: 100%;height: 100%"  @click="handleSetLanguage('mn')">
            Монгол хэл
          </div>
        </el-dropdown-item>
        <el-dropdown-item :disabled="language==='ar'">
          <div style="text-align: center;width: 100%;height: 100%"  @click="handleSetLanguage('ar')">
            العربية
          </div>
        </el-dropdown-item>
        <el-dropdown-item :disabled="language==='th'">
          <div style="text-align: center;width: 100%;height: 100%"  @click="handleSetLanguage('th')">
            ภาษาไทย
          </div>
        </el-dropdown-item>

        <el-dropdown-item :disabled="language==='vi'">
          <div style="text-align: center;width: 100%;height: 100%"  @click="handleSetLanguage('vi')">
            Tiếng Việt
          </div>
        </el-dropdown-item>
        <el-dropdown-item :disabled="language==='id'">
          <div style="text-align: center;width: 100%;height: 100%"  @click="handleSetLanguage('id')">
            Indonesia
          </div>
        </el-dropdown-item>
        <el-dropdown-item :disabled="language==='hu'">
          <div style="text-align: center;width: 100%;height: 100%"  @click="handleSetLanguage('hu')">
            Magyar
          </div>
        </el-dropdown-item>
        <el-dropdown-item :disabled="language==='fa'">
          <div style="text-align: center;width: 100%;height: 100%"  @click="handleSetLanguage('fa')">
            فارسی
          </div>
        </el-dropdown-item>
        <el-dropdown-item :disabled="language==='he'">
          <div style="text-align: center;width: 100%;height: 100%"  @click="handleSetLanguage('he')">
            עִבְרִית
          </div>
        </el-dropdown-item>
        <el-dropdown-item :disabled="language==='ko'">
          <div style="text-align: center"  @click="handleSetLanguage('ko')">
            <!--Chinese-->
            한국어
          </div>
        </el-dropdown-item>
        <el-dropdown-item :disabled="language==='ja'">
          <div style="text-align: center;width: 100%;height: 100%"  @click="handleSetLanguage('ja')">
            日本語
          </div>
        </el-dropdown-item>

      <div style="display: flex;flex-direction:row;justify-content: center;align-items: center;white-space: nowrap" slot="reference">
        <div class="btnIcon" :style="{'color': color}" style="display: flex;flex-direction:row;justify-content: center;align-items: center">
          <svg-icon icon-class="language"  class-name='left-menu-logo' style="margin-right: 5px"/>
        </div>
        <div class="btnTitle" :style="{'color': color}" >{{langNameTo}}</div>
        <i class="el-icon-caret-bottom" :style="{'color': color}" style="margin-right: -5px"></i>
      </div>
      </el-popover>
  </div>
</template>

<script>
  import Cookies from 'js-cookie'
    export default {
        name: "dashboard",
        props: {
          marginTop: {
            type: String,
            default:'0px'
          },
          marginRight: {
            type: String,
            default:'10px'
          },
          marginLeft: {
            type: String,
            default:'10px'
          },
          color: {
            type: String,
            default:'#ffffff'
          },
          refreshType:{
            type: Boolean,
            default:true
          }
        },
        data() {
            return{
              langList:[
                {id:'en',name:'English'},
                {id:'zh',name:'中文(简体)'},
                {id:'ko',name:'한국어'},
                {id:'zh_ft',name:'中文(繁體)'},
                {id:'fr',name:'Français'},
                {id:'es',name:'Español'},
                {id:'pt',name:'Português'},
                {id:'de',name:'Deutsch'},
                {id:'it',name:'Italiano'},
                {id:'ru',name:'Русский'},
                {id:'mn',name:'Монгол хэл'},
                {id:'ar',name:'العربية'},
                {id:'th',name:'ภาษาไทย'},
                {id:'vi',name:'Tiếng Việt'},
                {id:'id',name:'Indonesia'},
                {id:'hu',name:'Magyar'},
                {id:'fa',name:'فارسی'},
                {id:'he',name:'עִבְרִית'},
                {id:'ja',name:'日本語'},
              ]
            }
        },
        computed:{
          language() {
            // let lang = Cookies.get('language')
            // this.$store.getters.language = lang
            return this.$store.getters.language
          },
          langNameTo(){
            let data = this.langList.find(item => {
              return this.language == item.id
            })
            return data.name
          },
        },
        methods: {

          dashboard(){
            window.location.href="/dashboard/index"
          },
          handleSetLanguage(lang) {
            this.$i18n.locale = lang
            this.$store.dispatch('setLanguage', lang)
            this.$store.dispatch('setLanguage', lang)
            if(lang == "zh"){
              document.title = 'Q-NEX 工作台'
            }else if(lang == "en"){
              document.title = 'Q-NEX Console'
            }else if(lang == "ko"){
              document.title = 'Q-NEX Console'
            }else if(lang == "zh_ft"){
              document.title = 'Q-NEX 工作臺'
            }else{
              document.title = 'Q-NEX Console'
            }

            if(lang == "zh"){
              this.moment.locale('zh-cn');
            }else if(lang == "en"){
              this.moment.locale('en-gb');
            }else if(lang == "ko"){
              this.moment.locale('ko');
            }else{
              this.moment.locale('en-gb');
            }
            // let   integrityurl = window.location.host + window.location.pathname
            // window.location.href = integrityurl
            if(this.refreshType){
              this.$router.go(0)
            }

            // this.$message({
            //   message: 'switch language success',
            //   type: 'success'
            // })
            // this.$router.go(0)
          },
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .btnDashboard{
    width: 100px;
    display: inline-block;
    text-align: right;
    /*margin-right: 10px;*/
    line-height: 40px;
    cursor: pointer;
    .btnIcon{
      height: 40px;
      /* width: 40px; */
      line-height: 75px;
      color:rgba(255,255,255,1);
      font-size: 24px;
    }
    .btnTitle{
      font-size:14px;
      font-family:inter;
      font-weight:700;
      color:rgba(255,255,255,1);
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Language.vue